module.exports = __webpack_public_path__ + "static/media/IMG_4344.1eee11b4.JPG";